import { EyeIcon } from '@heroicons/react/24/solid'
import { Input, Toggle } from "@/components/ui"
import { useLocationForm } from './LocationFormContext'
import NewLocationFields from './NewLocationFields'
import Contact from "../biens/Contact"

export default ({formType}) => {
  // Récupérer les valeurs du contexte
  const { location, control, hasError, getErrorMessage, watch } = useLocationForm()

  const handleDownload = (file) => {
    window.open(location[file].url, '_blank')
  }

  const loyerSoldeRecu = watch("loyer_solde_recu")

  return (
    <div className={`grid grid-cols-1 md:grid-cols-3 gap-4`}>
      <div className="flex flex-col items-center gap-4">  
        { location.locataires?.length > 0 && location.locataires.map((locataire, index) => (
          <Contact key={locataire.id} label="Locataire" item={locataire} index={index} />
        ))}
      </div>

      <div className="flex flex-col items-start gap-4">
        { (formType && formType === "edit") && <h4 className="font-medium text-gray-600">Sortie de location :</h4> }
        <div className="w-full flex flex-wrap justify-between items-center pr-6">
          <div className='flex flex-col mb-1 w-80'>
            <Input.Currency 
              name={"montant_loyer_solde_sortie"}
              control={control}
              disabled={loyerSoldeRecu}
              label={"Solde loyer"}
            />
          </div>
          <Toggle.Form
            name={"loyer_solde_recu"}
            control={control}
            label={"Reçu"}
          />
        </div>
        <Input.Date 
          name={"date_etat_lieux_sortie"}
          control={control}
          label={"Date état des lieux"}
          validator={{hasError, getErrorMessage}}
        />
        <Input.Date 
          name={"date_fin_bail"}
          control={control}
          label={"Date fin du bail"}
          validator={{hasError, getErrorMessage}}
        />

        <div className="flex justify-between items-start pr-6">
            <Input.File control={control}
              name="etat_lieux_sortie_file"
              label="Etat des lieux"
              defaultValue={location.etat_lieux_sortie_file ? "Modifier le fichier" : ""}
              inputProps={{accept: [".pdf"]}}
              className="max-w-[350px]"
              canDelete={true}
            />
            { location.etat_lieux_sortie_file && (
              <button 
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  handleDownload("etat_lieux_sortie_file")
                }}
                className="btn btn-sm btn-ghost btn-square p-1 hover:bg-primary-400"
                title={`Voir l'état des lieux sortie`} aria-label={`Voir l'état des lieux sortie`}
              >
                <EyeIcon/>
              </button>
            )}
        </div>

      </div>

      { (formType && formType === "edit") &&
        <div className="flex flex-col items-start gap-4">  
          <h4 className="font-medium text-gray-600">Entrée de location :</h4>
          <NewLocationFields.Values />
          <NewLocationFields.Files />
        </div>
      }
    </div>
  )
}